module.exports = __webpack_public_path__ + "img/KSC05407-2.e9e67d97.jpg";